import { render, staticRenderFns } from "./Raumliste.vue?vue&type=template&id=971eb4e2&"
import script from "./Raumliste.vue?vue&type=script&lang=js&"
export * from "./Raumliste.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports